// 'de-DE' en vez de 'es-ES': mismos separadores (1.234,56) pero agrupa también los números de
// 4 cifras, que es-ES deja sin punto ("4883" junto a "19.496").
const LOCALE = 'de-DE'

export const eur = (n, digits = 2) =>
  (Number(n) || 0).toLocaleString(LOCALE, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: digits,
    maximumFractionDigits: Math.max(digits, 2)
  })

export const num = (n) => (Number(n) || 0).toLocaleString(LOCALE)

export const pct = (part, total) =>
  total > 0 ? `${((part / total) * 100).toFixed(0)}%` : '—'

export const marginPct = (margin, retail) =>
  retail > 0 ? `${((margin / retail) * 100).toFixed(1)}%` : '—'

// 'YYYY-MM-DD' -> 'DD/MM/YYYY'
export const dmy = (ymd) => (ymd ? ymd.split('-').reverse().join('/') : '')

export const dateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString('es-ES', {
        timeZone: 'Europe/Madrid',
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    : '—'

export const dateOnly = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString('es-ES', {
        timeZone: 'Europe/Madrid',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    : '—'

export const COLORS = {
  conversacion: '#4F46E5',
  extra: '#A855F7',
  simple: '#0EA5E9',
  basico: '#94A3B8',
  incluido: '#10B981',
  fallido: '#EF4444'
}

// Descarga un CSV (separador ';' para que Excel en español lo abra en columnas)
export const downloadCsv = (filename, header, rows) => {
  const esc = (v) => {
    const s = v === null || v === undefined ? '' : String(v)
    return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
  }
  const body = [header, ...rows].map((r) => r.map(esc).join(';')).join('\n')
  const blob = new Blob(['﻿' + body], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

// Nombres legibles de los pasos más comunes; el resto se muestra tal cual.
export const STEP_LABEL = {
  init: 'Mensaje inicial',
  closed: 'Respuesta: flujo cerrado',
  nameCheck: 'Pregunta el nombre',
  dniCheck: 'Pide letra del DNI',
  dniSecondTry: 'DNI: 2º intento',
  dniLastTry: 'DNI: último intento',
  dniFailed: 'DNI fallido',
  checkReason: 'Motivo del impago',
  contactInfo: 'Datos de contacto',
  contactInfoNoAuth: 'Datos de contacto (sin identificar)',
  callme: 'Confirma llamada',
  pagarPortal: 'Pagar online',
  dontknow: 'No entiende la respuesta',
  thanksEnd: 'Despedida',
  satisfaction: 'Encuesta de satisfacción'
}

export const stepLabel = (v) =>
  STEP_LABEL[v] || (v && v.startsWith('selectSchedule') ? 'Elegir horario de llamada' : v) || '—'
